import noop from 'lodash.noop';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/**
 * By default, printing is only enabled in non-production environments.
 *
 * This behavior can be customized by defining a UNLY_SIMPLE_LOGGER_ENV which will be matched against "production".
 * This is useful when dealing with multi stages (dev, staging, production) and you want to enable logs on all stages but not for production.
 */

var shouldPrintFallback = function shouldPrintFallback() {
  if (process.env.UNLY_SIMPLE_LOGGER_ENV) {
    return process.env.UNLY_SIMPLE_LOGGER_ENV !== 'production';
  }

  return process.env.NODE_ENV !== 'production';
};
/**
 * By default, displays the time as a Date ISO string.
 */

var timeFormatFallback = function timeFormatFallback() {
  return new Date().toISOString();
};
/**
 * By default, show time unless SIMPLE_LOGGER_SHOULD_SHOW_TIME has been explicitly set to "false".
 */

var shouldShowTimeFallback = function shouldShowTimeFallback() {
  return process.env.SIMPLE_LOGGER_SHOULD_SHOW_TIME !== 'false';
};
/**
 * Colorize output.
 *
 * Only colorize on the server, not on the browser
 * (keep native behavior, to avoid messing with colors and complicated browser API which is different for each browser).
 *
 * @param mode
 * @param prefixes
 */


var colorizeFallback = function colorizeFallback(mode, prefixes) {
  if (typeof window === 'undefined') {
    var chalk = require('chalk'); // Require chalk on the server only, should not be included in the browser bundle


    var orange = chalk.hex('#FFA500');

    switch (mode) {
      case 'debug':
        return prefixes.map(function (prefix) {
          return chalk.yellow(prefix);
        });

      case 'error':
        return prefixes.map(function (prefix) {
          return chalk.red(prefix);
        });

      case 'group':
        return prefixes.map(function (prefix) {
          return chalk.bgGray(prefix);
        });

      case 'info':
        return prefixes.map(function (prefix) {
          return chalk.blue(prefix);
        });

      case 'log':
        return prefixes.map(function (prefix) {
          return chalk.grey(prefix);
        });

      case 'warn':
        return prefixes.map(function (prefix) {
          return orange(prefix);
        });
    }
  }

  return prefixes;
};
/**
 * Creates a logger object containing the same "print" API as the console object.
 *
 * Compatible with server and browser. (universal)
 *
 * @param options
 */


var createSimpleLogger = function createSimpleLogger(options) {
  var _console$debug, _console$error, _console$group, _console$info, _console$log, _console$warn;

  var _ref = options || {},
      prefix = _ref.prefix,
      _ref$shouldPrint = _ref.shouldPrint,
      shouldPrint = _ref$shouldPrint === void 0 ? shouldPrintFallback : _ref$shouldPrint,
      _ref$disableAutoWrapP = _ref.disableAutoWrapPrefix,
      disableAutoWrapPrefix = _ref$disableAutoWrapP === void 0 ? false : _ref$disableAutoWrapP,
      _ref$shouldShowTime = _ref.shouldShowTime,
      shouldShowTime = _ref$shouldShowTime === void 0 ? shouldShowTimeFallback : _ref$shouldShowTime,
      _ref$timeFormat = _ref.timeFormat,
      timeFormat = _ref$timeFormat === void 0 ? timeFormatFallback : _ref$timeFormat,
      _ref$colorize = _ref.colorize,
      colorize = _ref$colorize === void 0 ? colorizeFallback : _ref$colorize;

  var _prefix = disableAutoWrapPrefix || !(prefix != null && prefix.length) ? prefix : "[" + prefix + "]";

  var prefixes = []; // Contains an array of prefixes (tags, time, etc.)

  if (shouldShowTime()) {
    prefixes.push(timeFormat());
  }

  if (_prefix) {
    prefixes.push(_prefix);
  }

  return _extends({}, console, {
    debug: shouldPrint('debug') ? (_console$debug = console.debug).bind.apply(_console$debug, [console].concat(colorize('debug', prefixes))) : noop,
    error: shouldPrint('error') ? (_console$error = console.error).bind.apply(_console$error, [console].concat(colorize('error', prefixes))) : noop,
    group: shouldPrint('group') ? (_console$group = console.group).bind.apply(_console$group, [console].concat(colorize('group', prefixes))) : noop,
    groupEnd: shouldPrint('groupEnd') ? console.groupEnd.bind(console) : noop,
    info: shouldPrint('info') ? (_console$info = console.info).bind.apply(_console$info, [console].concat(colorize('info', prefixes))) : noop,
    log: shouldPrint('log') ? (_console$log = console.log).bind.apply(_console$log, [console].concat(colorize('log', prefixes))) : noop,
    warn: shouldPrint('warn') ? (_console$warn = console.warn).bind.apply(_console$warn, [console].concat(colorize('warn', prefixes))) : noop
  });
};

export default createSimpleLogger;
export { createSimpleLogger, shouldPrintFallback, timeFormatFallback };
//# sourceMappingURL=simple-logger.esm.js.map
